import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YouTubePlayerModule } from "@angular/youtube-player";

import { FrontendRoutingModule } from './frontend-routing.module';
import { PlantingSiteDetailsComponent } from './planting-site-details/planting-site-details.component';
import { HomeComponent } from './home/home.component';
import { CoreModule } from '../core/core.module';
import { PlantingSiteListComponent } from './planting-site-list/planting-site-list.component';
import { ListMapComponent } from './planting-site-list/list-map/list-map.component';
import { ListGridComponent } from './planting-site-list/list-grid/list-grid.component';
import { AgmCoreModule } from '@agm/core';
import { FrontendComponent } from './frontend.component';
import { CollectionDetailComponent } from './collection-detail/collection-detail.component';
import { VideoDetailComponent } from './video-detail/video-detail.component';
import { CollectionMapComponent } from './collection-map/collection-map.component';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { CollectionDialogComponent } from './collection-dialog/collection-dialog.component';
import { PlantingSitePlaceholderComponent } from './planting-site-list/planting-site-placeholder.component';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ModalPlantingSiteDetailsComponent } from './planting-site-details/modal-planting-site-details/modal-planting-site-details/modal-planting-site-details.component';
import { PlantingSiteEmbededComponent } from './planting-site-embeded/planting-site-embeded.component';
import { CollectionMapEmbededComponent } from './collection-map-embeded/collection-map-embeded.component';
import { CollectionDetailEmbededComponent } from './collection-detail-embeded/collection-detail-embeded.component';
import { VideoDetailEmbededComponent } from './video-detail-embeded/video-detail-embeded.component';

@NgModule({
    declarations: [
        PlantingSiteDetailsComponent,
        HomeComponent,
        PlantingSiteListComponent,
        ListMapComponent,
        ListGridComponent,
        FrontendComponent,
        CollectionDetailComponent,
        VideoDetailComponent,
        CollectionMapComponent,
        CollectionDialogComponent,
        PlantingSitePlaceholderComponent,
        ModalPlantingSiteDetailsComponent,
        PlantingSiteEmbededComponent,
        CollectionMapEmbededComponent,
        CollectionDetailEmbededComponent,
        VideoDetailEmbededComponent
    ],
    imports: [
        BsDropdownModule.forRoot(),
        CommonModule,
        FrontendRoutingModule,
        CoreModule,
        AgmCoreModule,
        AgmSnazzyInfoWindowModule,
        CollapseModule.forRoot(),
        TabsModule.forRoot(),
        AgmJsMarkerClustererModule,
        YouTubePlayerModule
    ],
    entryComponents: [
        ModalPlantingSiteDetailsComponent,
     ]
})
export class FrontendModule { }
